/**
 * Preserves empty paragraphs in HTML by inserting a non-breaking space (&nbsp;).
 * This ensures empty <p> tags are visible when rendered.
 *
 * @param html - The HTML string to process
 * @returns HTML string with empty paragraphs replaced by <p>&nbsp;</p>
 */
export function preserveEmptyParagraphs(html: string): string {
  if (!html) return '';
  return html.replace(/<p>\s*<\/p>/g, '<p>&nbsp;</p>');
}
